import React, { useState, useEffect } from "react";
import ParcelShipmentsSearch from "./parcel-shipments-search.component";
import ParcelShipmentsGrid from "./parcel-shipments-grid.component";
import "./parcel-shipments.scss";
import * as ParcelShipmentsServices from "./parcel-shipments.services";
import ParcelShipmentsTrackingDetails from "./parcel-shipments-tracking-details";
import * as GlobalService from "../react/global_services";
interface Props {}

declare var window: any;
var $rootScope = window;
const wmsSelector = "ParcelShipments";
const defaultFilterValue = {
    SearchTarget: "",
    IndexOptionsSearchBy: "2",
    StartDate: "1weekago~00:00:00",
    EndDate: "",
    DeliveryStatus: "",
    IndexOptionsCustomerId: "0",
    IndexOptionsFacilityId: "0",
    Carrier: "",
    ShipService: "",
};
const gridId = "ParcelShipmentsGrid";

const ParcelShipmentsHolder: React.FC<Props> = (props: Props): any => {
    const [windowId] = useState($rootScope.ChildBulletin.Data.Window);
    const gridDomSelector = windowId ? "." + windowId + " #" + gridId : "#" + gridId;
    const [sharedSearchOn, setSharedSearchOn] = useState(false);
    const [sharedFilterObject, setSharedFilterObject] = useState(defaultFilterValue);
    const [loadGrid, setLoadGrid] = useState(false);
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [filterAreaToggle, setFilterAreaToggle] = useState(false);
    const [isAnimatedClassAdded, setIsAnimatedClassAdded] = useState(false);
    const [isOpenDetailsView, setIsOpenDetailsView] = useState(false);
    const [gridInlineFilter, setGridInlineFilter] = useState("");
    const [isSavedFilterUpdate, setIsSavedFilterUpdate] = useState(false);
    const [trackingInfo, setTrackingInfo] = useState(null);

    useEffect(() => {
        async function getGridMeta() {
            await ParcelShipmentsServices.getParcelShipmentsClientMetaData();
            let filterData = ParcelShipmentsServices.getParcelShipmentsFilterMetaData();
            if (filterData) {
                setSharedFilterObject(filterData);
            }
            setLoadGrid(true);
            setIsSavedFilterUpdate(true);
            setTimeout(() => {
                setIsSavedFilterUpdate(false);
            }, 500);
        }
        ParcelShipmentsServices.getShipEngineCarriers().then((response: any) => {
            if (response.data && response.data.Carriers) {
                response.data.Carriers.unshift({
                    id: 0,
                    DisplayName: "Unspecified",
                    Carrier: "",
                });
                setCarrierOptions(response.data.Carriers);
            }
        });
        getGridMeta();
    }, []);

    const onClearSearch = () => {
        ParcelShipmentsServices.clearParcelShipmentsFilterMetaData();
        setSharedSearchOn(false);
        setSharedFilterObject(defaultFilterValue);
    };

    const onFilterDataSet = (filterObject: any) => {
        if (
            filterObject.CustomerID !== 0 ||
            filterObject.FacilityID !== 0 ||
            filterObject.WarehouseTransactionID !== null ||
            filterObject.ReferenceNum !== null ||
            filterObject.StartDate !== null ||
            filterObject.EndDate !== null
        ) {
            setSharedSearchOn(true);
        }
        setSharedFilterObject(filterObject);
        ParcelShipmentsServices.setParcelShipmentsFilterMetaData(filterObject);
    };
    const clickForFilterToggle = () => {
        setFilterAreaToggle(!filterAreaToggle);
        setIsAnimatedClassAdded(true);
        setTimeout(() => {
            setIsAnimatedClassAdded(false);
            $("#" + gridId)
                .data("kendoGrid")
                .refresh();
            $(window).trigger("resize");
        }, 1000);
    };

    const hideFilterToggle = (flag: boolean) => {
        setIsOpenDetailsView(flag);
        setFilterAreaToggle(flag);
        resizeWindow();
        setTrackingInfo(null);
        // if (!flag) {
        //     let grid = $(gridDomSelector).data("kendoGrid");
        //     grid.clearSelection();
        //     // grid.tbody.find("tr[aria-selected]").removeAttr("aria-selected");
        //     // grid.tbody.find(".k-state-selected").removeClass("k-state-selected");
        //     // grid.current(null);
        // }
    };

    const setTrackingInfoData = (data: any) => {
        // console.log("data", data);
        setTrackingInfo(data);
    };

    const resizeWindow = () => {
        $(window).trigger("resize");
    };
    // click on save search filter in meta data
    const onManageFilter = (param_action, param_data) => {
        var filterData = Object.assign({}, sharedFilterObject);
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid && grid.dataSource.sort() ? grid.dataSource.sort() : [];
        var filterArray = grid && grid.dataSource.filter() ? grid.dataSource.filter() : [];
        var gridColumn = grid.getOptions().columns;
        var finalSubmission = GlobalService.prepareGridOptionsForStorage(gridColumn, sortArray, filterArray);
        if (param_action === "saveFilter") {
            ParcelShipmentsServices.saveParcelShipmentsFilterMetaData(
                param_data,
                JSON.parse(JSON.stringify(filterData)),
                finalSubmission
            );
        } else {
            ParcelShipmentsServices.updateParcelShipmentsFilterMetaData(
                param_data,
                JSON.parse(JSON.stringify(filterData)),
                finalSubmission
            );
            GlobalService.notification("success", window.translate("Order_Filter_Update_success"));
        }
        setIsSavedFilterUpdate(true);
        setTimeout(() => {
            setIsSavedFilterUpdate(false);
        }, 500);
    };
    let onApplySavedFilter = (param_filterObj) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var tmpGridInlineFilter: any;
        if (grid) {
            tmpGridInlineFilter = grid.dataSource.filter();
        }
        setSharedFilterObject(param_filterObj);
        setSharedSearchOn(true);
        setGridInlineFilter(tmpGridInlineFilter);
    };
    return (
        <div
            className={`
                parcel-shipments-holder-wrapper new-layout-grid-filter-wrapper
                ${filterAreaToggle ? "collapsedFilter" : "expandFilter"}
                ${isAnimatedClassAdded ? "animatedCollapse" : ""}
            `}
        >
            <ParcelShipmentsSearch
                wmsSelector={wmsSelector}
                sharedSearchOn={sharedSearchOn}
                sharedFilterObject={sharedFilterObject}
                onClearSearch={onClearSearch}
                onFilterDataSet={onFilterDataSet}
                onClickForFilterToggle={clickForFilterToggle}
                windowId={windowId}
                carrierOptions={carrierOptions}
                onManageFilter={onManageFilter}
                onApplySavedFilter={onApplySavedFilter}
                isSavedFilterUpdate={isSavedFilterUpdate}
                gridId={gridId}
                trackingInfo={trackingInfo}
            />
            {loadGrid && (
                <>
                    <ParcelShipmentsGrid
                        wmsSelector={wmsSelector}
                        windowId={windowId}
                        sharedFilterObject={sharedFilterObject}
                        hideFilterToggle={hideFilterToggle}
                        gridInlineFilter={gridInlineFilter}
                        setTrackingInfoData={setTrackingInfoData}
                        gridId={gridId}
                    />

                    {isOpenDetailsView && (
                        <ParcelShipmentsTrackingDetails
                            wmsSelector={wmsSelector}
                            trackingInfo={trackingInfo}
                            onExitShipmentDetails={() => hideFilterToggle(false)}
                            windowId={windowId}
                        />
                    )}
                </>
            )}
        </div>
    );
};
ParcelShipmentsHolder.propTypes = {};

export default React.memo(ParcelShipmentsHolder);
